import axios from 'axios';
import { useAuthStore } from '../store/authStore';
import { loginUrlFor } from '../lib/safeNext';

// Create axios instance with base configuration
const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:5001/api',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    // Get token from Zustand persist storage
    const authStorage = localStorage.getItem('auth-storage');
    if (authStorage) {
      try {
        const authData = JSON.parse(authStorage);
        const token = authData.state?.token;
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      } catch (error) {
        console.error('Error parsing auth storage:', error);
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle common errors
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      const reqUrl = error.config?.url || '';
      const isAuthLogin = reqUrl.includes('/auth/login');

      // For invalid login attempts, don't redirect/reload; let caller handle the message
      if (isAuthLogin) {
        return Promise.reject(error);
      }

      // Check if it's a deactivation error
      const errorMessage = error.response?.data?.error;
      if (errorMessage && errorMessage.includes('deactivated')) {
        alert('Your account has been deactivated. Please contact administrator.');
      }

      // Token expired or invalid - clear storage and redirect to login, coming back here after
      localStorage.removeItem('auth-storage');
      window.location.href = loginUrlFor(window.location);
      return; // stop further processing
    }

    // On 403 Forbidden, the user's role may have changed - refresh user data
    if (error.response?.status === 403) {
      const reqUrl = error.config?.url || '';
      if (!reqUrl.includes('/auth/me')) {
        api.get('/auth/me').then((res) => {
          if (res.data?.success) {
            useAuthStore.getState().updateUser(res.data.data.user);
          }
        }).catch(() => {});
      }
    }

    return Promise.reject(error);
  }
);

export default api;
